<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="720" [nzVisible]="isVisible"
  [nzTitle]=" data ? 'Edit Client' : 'Create New Client'" [nzFooter]="footerTpl" (nzOnClose)="closeonly()"
  [nzSize]="'default'">
  <form nz-form *nzDrawerContent [formGroup]="clientForm" (ngSubmit)="onSubmit()">
    <!-- Client Details Section -->
    <fieldset>
      <!-- <legend>Client Details</legend> -->
      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Client Name</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please enter client name">
          <input nz-input formControlName="name" placeholder="Enter client name" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Client Website</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please enter a valid website">
          <!-- <nz-input-group nzAddOnBefore="https://"> -->
          <input type="text" nz-input formControlName="website" placeholder="Enter website" />
          <!-- </nz-input-group> -->
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="7">Client Phone</nz-form-label>
        <nz-form-control [nzSpan]="17">
          <nz-input-group [nzAddOnBefore]="addOnBeforeTemplate">
            <ng-template #addOnBeforeTemplate>

              <nz-select nzShowSearch nzAllowClear formControlName="country_code" class="phone-select"
                nzPlaceHolder="+91" style="color: rgba(0, 0, 0, 0.88); font-weight: normal;">
                @for (countryCode of countryCodeList; track countryCode.id) {
                <nz-option [nzValue]="countryCode.id"
                  [nzLabel]="`${countryCode.code} ${countryCode.country_name}`"></nz-option>
                }
              </nz-select>
            </ng-template>
            <input formControlName="phone" id="phoneNumber" nz-input placeholder="Enter phone number" />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="7">Client LinkedIn URL</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please enter a valid LinkedIn username">
          <!-- <nz-input-group nzAddOnBefore="https://"> -->
          <input nz-input type="text" formControlName="linkedin" placeholder="Enter LinkedIn username" />
          <!-- </nz-input-group> -->
        </nz-form-control>
      </nz-form-item>
    </fieldset>

    <!-- <nz-form-item>
      <nz-form-label [nzSpan]="7">Job Title</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please enter job title">
        <input nz-input formControlName="job_title" placeholder="Enter job title" />
      </nz-form-control>
    </nz-form-item> -->

    <nz-form-item>
      <nz-form-label [nzSpan]="7">Onboarding Date</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please select onboarding date">
        <input nz-input type="date" formControlName="onboarding_date" [max]="getMaxDate()" />
      </nz-form-control>
    </nz-form-item>



    <!-- Address Section -->
    <fieldset style="padding-left: 42px;padding-bottom:20px">
      <legend style="color:#000000d9;font-size:14px;font-weight: 600;"><span style="color:red">*</span> Address Details
      </legend>
      <nz-row [nzGutter]="[16,16]">
        <nz-col *ngFor="let address of clientForm.get('address').value; let i = index; e" [nzSpan]="12">
          <div class="poc-wrapper">
            <nz-avatar [nzSrc]="getIcon(address?.address_field_1[0])" [nzSize]="30"
              style="flex: 0 0 30px; margin-right: 10px;cursor: pointer; margin-top: 8px;background:#736af7;margin-left:10px"></nz-avatar>

            <div style="flex: 1;">
              <div class="poc-name" style="color: #555;"> <strong>{{ address?.address_field_1 | titlecase }} </strong>
              </div>
              <div class="poc-phone" style="color: #555;"> {{ address?.address_field_2 | titlecase }}</div>
              <div class="poc-phone" style="color: #555;"> {{ address?.country_name }} <span
                  *ngIf="address?.state_name">,</span> {{ address?.state_name }} <span
                  *ngIf="address?.city_name ">,</span> {{ address?.city_name }} <span
                  *ngIf="address?.zip_code ">,</span> {{ address?.zip_code }} </div>
              <div class="poc-phone" style="color: #555;"> <nz-tag [nzColor]="'blue'"
                  style="font-size:9px;line-height: 1;margin-top:6px;padding:4px" [nzBordered]="true"> {{
                  address?.address_type_name.toLowerCase() == 'official' ? 'Headquarter' : address?.address_type_name
                  }}</nz-tag> </div>

            </div>
            <button type="button" nz-button nzType="text" nzSize="small" style="margin-left: 8px;" nz-tooltip
              [nzTooltipTitle]="'Edit'" nzTooltipPlacement="top" (click)="updateAddress(address)">
              <nz-icon nzType="edit" nzTheme="outline" />
            </button>

            <!-- <button
              nz-button
              nzType="text"
              nzDanger
              nzSize="small"
              nz-tooltip
              [nzTooltipTitle]="'Delete'"
              nzTooltipPlacement="top"
              [nz-popconfirm]="deleteAddressPopconfirm"
              [nzPopconfirmTitle]="''"
              [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
              nzPopconfirmPlacement="bottom"
              (nzOnConfirm)="deleteAddress(address)"
            >
              <nz-icon nzType="delete" nzTheme="outline" />
            </button> -->

          </div>
        </nz-col>

        <nz-col [nzSpan]="12">
          <div class="poc-wrapper add-poc" (click)="openAddAddress()">
            <nz-avatar nzIcon="plus" [nzSize]="38"
              style="flex: 0 0 38px; cursor: pointer; margin-top: 8px;background:#736af7;margin-left:10px"></nz-avatar>
            <div class="info">
              <div class="name">Add New Address</div>
              <p><span nz-typography nzType="secondary">Click to add new Address</span></p>
            </div>
          </div>
        </nz-col>
        <nz-col [nzSpan]="24"
          *ngIf="clientForm.get('address').dirty && (!clientForm.get('address').value || clientForm.get('address').value?.length == 0)">
          <p style="color:red;font-size:11px;padding-bottom:0px">Please enter Address details.</p>
        </nz-col>
      </nz-row>
    </fieldset>

    <!-- POC Contact Details Section -->
    <fieldset style="padding-left: 42px;;padding-bottom:20px">
      <legend style="color:#000000d9;font-size:14px;font-weight: 600;">POC Contact
        Details</legend>
      <nz-row [nzGutter]="[16,16]">
        <nz-col *ngFor="let pocs of clientForm.get('poc').value; let i = index; trackBy: trackByPocId" [nzSpan]="12">
          <div class="poc-wrapper">
            <nz-avatar [nzSrc]="getIcon(pocs?.poc_name[0])" [nzSize]="30" style="flex: 0 0 30px; margin-right: 10px;">
            </nz-avatar>

            <div style="flex: 1;white-space: wrap;">
              <div class="poc-name"><strong>{{ pocs?.poc_name }}</strong></div>
              <div class="poc-phone" style="color: #555;" *ngIf="pocs?.job_title">{{ pocs?.job_title }}</div>
              <div class="poc-email" style="color: #555;word-break: break-all;">📧 {{ pocs?.poc_email }}</div>
              <div class="poc-linkedin" style="color: #555;" *ngIf="pocs?.poc_linkedin">
                🔗 <a [href]="'https://' + pocs?.poc_linkedin" target="_blank">{{ pocs?.poc_linkedin }}</a>
              </div>
              <div class="poc-phone" style="color: #555;">📞{{ getCountryCode(pocs?.country_code) }} {{ pocs?.poc_phone
                || 'N/A' }}</div>
              <div class="mark-primary">
                <p class="mark-primary-btn" *ngIf="pocs.type == 2 && !data" (click)="markPrimary(pocs)">Set Primary</p>
                <p *ngIf="pocs.type == 1" style="margin-bottom: 0px;"> <nz-tag [nzColor]="'blue'"
                    style="font-size:9px;line-height: 1;margin-top:6px;;padding:4px" [nzBordered]="true"> Primary
                  </nz-tag> </p>
              </div>
            </div>
            <button type="button" nz-button nzType="text" nzSize="small" style="margin-left: 8px;" nz-tooltip
              [nzTooltipTitle]="'Edit'" nzTooltipPlacement="top" (click)="editPOC(pocs)">
              <nz-icon nzType="edit" nzTheme="outline" />
            </button>

            <button
              nz-button
              nzType="text"
              nzDanger
              nzSize="small"
              nz-tooltip
              [nzTooltipTitle]="'Delete'"
              nzTooltipPlacement="top"
              [nz-popconfirm]="deletePOCPopconfirm"
              [nzPopconfirmTitle]="''"
              [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
              nzPopconfirmPlacement="bottom"
              (nzOnConfirm)="deletePOC(pocs)"
            >
              <nz-icon nzType="delete" nzTheme="outline" />
            </button>
          </div>
        </nz-col>

        <nz-col [nzSpan]="12">
          <div class="poc-wrapper add-poc" (click)="openAddPoc()">
            <nz-avatar nzIcon="plus" [nzSize]="38"
              style="flex: 0 0 38px; cursor: pointer; margin-top: 8px;margin-left:10px;background:#736af7;"></nz-avatar>
            <div class="info">
              <div class="name">Add New POC</div>
              <p><span nz-typography nzType="secondary">Click to add new POC</span></p>
            </div>
          </div>
        </nz-col>
        <nz-col [nzSpan]="24"
          *ngIf="clientForm.get('poc').dirty && (!clientForm.get('poc').value || clientForm.get('poc').value?.length == 0)">
          <p style="color:red;font-size:11px;padding-bottom:0px">Please enter POC details.</p>
        </nz-col>

      </nz-row>
    </fieldset>

    <!-- Sales Information Section -->
    <fieldset>
      <!-- <legend>Sales Information</legend> -->
      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Salesperson</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please select a salesperson">
          <nz-select nzShowSearch nzAllowClear formControlName="salesperson" nzPlaceHolder=" Select a salesperson">
            @for (person of userlist; track person.id) {
            <nz-option *ngIf="person.is_sales_person" [nzValue]="person.id" [nzLabel]="`${person.name}`"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </fieldset>
  </form>

  <ng-template #footerTpl>
    <div style="float: right">
      <button nz-button style="margin-right: 8px;" (click)="closeonly()">Cancel</button>
      <button nz-button nzType="primary" (click)="onSubmit()" [nzLoading]="isSubmitting"> {{ data ? 'Update' : 'Create'
        }} </button>
    </div>
  </ng-template>
</nz-drawer>


<app-client-add-poc [isVisible]="isVisibleAddPoc" [data]="editPocData" [clientID]="data?.id"
  (closeDrawer)="closeAddPocEvent($event)" (closeDrawerData)="closeAddPoc($event)"
  [allPOCData]="data?.poc_details ? data?.poc_details : []"></app-client-add-poc>

<!--  (closeDrawerData)="closeAddPoc($event)"  -->

<app-client-add-address [isVisible]="isVisibleAddAddress" [data]="addressData" [clientID]="data?.id"
  (closeDrawer)="closeAddAddressEvent($event)" (closeDrawerData)="closeAddAddress($event)"></app-client-add-address>

<!--  (closeDrawerData)="closeAddAddress($event)"  -->

<ng-template #deletePOCPopconfirm>
  <div class="custom-popconfirm-header">
    <span class="custom-popconfirm-title">Confirm Deletion</span>
  </div>
  <div class="custom-popconfirm-icon-area">
    <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
      <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
    </span>
  </div>
  <div class="custom-popconfirm-message description">
    Are you sure you want to delete this POC?<br />
    <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
  </div>
</ng-template>

<ng-template #deleteAddressPopconfirm>
  <div class="custom-popconfirm-header">
    <span class="custom-popconfirm-title">Confirm Deletion</span>
  </div>
  <div class="custom-popconfirm-icon-area">
    <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
      <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
    </span>
  </div>
  <div class="custom-popconfirm-message description">
    Are you sure you want to delete this Address?<br />
    <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
  </div>
</ng-template>